module.exports = __webpack_public_path__ + "static/q18_x-781cef36731f19c2aa5fc6ebdf5f47ff.png";